// Paginated list + filter state for the campaigns dashboard.
// Filters live in Redux so they survive route changes inside the feature.

import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useListCampaignsQuery } from '../campaignsApi';
import {
  selectListFilters,
  selectListPage,
  setListFilters,
  clearListFilters,
  setListPage,
} from '../campaignsSlice';

export const useCampaignsList = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectListFilters);
  const page = useSelector(selectListPage);

  const { data, isLoading, isFetching, isError, refetch } = useListCampaignsQuery({ filters, page });

  const updateFilters = useCallback((patch) => dispatch(setListFilters(patch)), [dispatch]);
  const clearFilters = useCallback(() => dispatch(clearListFilters()), [dispatch]);
  const goToPage = useCallback((next) => dispatch(setListPage(next)), [dispatch]);

  return {
    items: data?.items ?? [],
    total: data?.total ?? 0,
    page,
    pageSize: data?.pageSize ?? 20,
    filters,
    isLoading,
    isFetching,
    isError,
    updateFilters,
    clearFilters,
    goToPage,
    refetch,
  };
};
